import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Container, HeaderRow, ArrowWrapper, List, ListItem, AgentNameWrap } from "./AgentsList.styled";
import { Typography, Icon } from "@ann/web-components";
import { useHomeChat } from "../../../../context";

const AGENTS_VIEW_PATH = "/v2/agentsview";

const AgentsList = () => {
  const navigate = useNavigate();
  const { agents, selectedAgentId, selectAgent } = useHomeChat();

  const handleHeaderClick = useCallback(() => {
    navigate(AGENTS_VIEW_PATH);
  }, [navigate]);

  const handleSelectAgent = useCallback(
    (agent) => {
      const agentId = agent.uuid || agent.id;
      selectAgent(agentId, agent);
    },
    [selectAgent]
  );

  const sortedAgents = useMemo(() => {
    if (!agents || agents.length === 0) return [];
    return [...agents].sort((a, b) => {
      const nameA = (a.name || "").toUpperCase();
      const nameB = (b.name || "").toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  }, [agents]);

  return (
    <Container>
      <HeaderRow
        onClick={handleHeaderClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleHeaderClick()}
      >
        <Typography category="subtitle" size="small" weight="bold">
          Agents
        </Typography>
        <ArrowWrapper>
          <Icon name="chevronRight" size="medium" color="neutral" />
        </ArrowWrapper>
      </HeaderRow>

      <List>
        {sortedAgents.length === 0 ? (
          <ListItem $isSelected={false}>
            <Typography category="body" size="medium" weight="regular" color="body">
              No agents available
            </Typography>
          </ListItem>
        ) : (
          sortedAgents.map((agent) => {
            const agentId = agent.uuid || agent.id;
            return (
              <ListItem
                key={agentId}
                onClick={() => handleSelectAgent(agent)}
                $isSelected={selectedAgentId === agentId}
              >
                <AgentNameWrap>
                  <Typography 
                    category="body" 
                    size="medium" 
                    weight="regular" 
                    color="body"
                    title={agent.name || "Unnamed Agent"}
                  >
                    {agent.name || "Unnamed Agent"}
                  </Typography>
                </AgentNameWrap>
              </ListItem>
            );
          })
        )}
      </List>
    </Container>
  );
};

export default AgentsList;
